import React from 'react'
import { Layout } from 'antd';
import {Route, withRouter} from 'react-router-dom'
import Navigation from '../../components/navigation'
import AsyncComponent  from '@/components/asyncComponent';
const { Content } = Layout;
function Contents(props) {
    return (
            <Content
                style={{ margin: '0 16px' }}
            >
                <Navigation routerPath={props.history}/>
                <div
                    className="site-layout-background"
                    style={{ padding: 16, minHeight:'calc(100vh - 200px)' }}
                >
                    <Route
                        component={AsyncComponent(() => import(`@/views${props.routerPath.location.pathname}`) )}
                        path={props.routerPath.location.pathname}
                    />
                    <Route
                        component={AsyncComponent(() => import('@/views/exception/404') )}
                        path="/exception/404"
                    />
                    <Route
                        component={AsyncComponent(() => import('@/views/exception/403') )}
                        path="/exception/403"
                    />
                    <Route
                        component={AsyncComponent(() => import('@/views/exception/500') )}
                        path="/exception/500"
                    />
                </div>
            </Content>
    )
}
export default withRouter(Contents)
